import useUserStore from "@/store/useUserStore";
import { bcp47Helper } from "./bcp47Helper";
import { floorNumber } from "./number";

export const formatDuration = (
	days: number,
	hours: number,
	minutes: number,
	seconds: number,
): string => {
	// TODO: Toto netreba prekladat ?
	if (days > 0) return `${days}d ${hours.toString().padStart(2, "0")}h`;
	if (hours > 0) return `${hours}h ${minutes.toString().padStart(2, "0")}m`;
	if (minutes >= 1)
		return `${minutes}m ${seconds.toString().padStart(2, "0")}s`;
	return `${seconds}s`;
};

export const formatDurationShort = (
	days: number,
	hours: number,
	minutes: number,
): string => {
	// TODO: Toto netreba prekladat ?
	if (days > 0) return `${days}d ${hours.toString().padStart(2, "0")}h`;
	if (hours > 0) return `${hours}h ${minutes.toString().padStart(2, "0")}m`;
	if (minutes >= 1) return `${minutes}m`;
	return "";
};

export const formatMillisecondsDuration = (
	ms: number,
	withSeconds: boolean = false,
): string => {
	if (ms <= 0) return "0s";

	const totalSeconds = floorNumber(ms / 1000);
	const days = floorNumber(totalSeconds / 86400);
	const hours = floorNumber((totalSeconds % 86400) / 3600);
	const minutes = floorNumber((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;

	if (withSeconds) return formatDuration(days, hours, minutes, seconds);
	return formatDurationShort(days, hours, minutes);
};

export const formatNumber = (
	value: number,
	useShortFormat: boolean = false,
	withoutTags: boolean = false,
): string => {
	if (useShortFormat && value >= 1_000_000) {
		return abbrNumber(value, withoutTags);
	}
	return value
		? new Intl.NumberFormat(bcp47Helper(useUserStore().language)).format(
				value,
			)
		: "0"; // Tuto musi byt tento fallback na nulu, lebo v resourcoch ak idem zo zaporneho cisla na nulu, tak zobrazi pred nulou minus.}
};

export const formatPercent = (
	value: number,
	fractionDigits: number = 0,
): string =>
	new Intl.NumberFormat(bcp47Helper(useUserStore().language), {
		style: "percent",
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	}).format(value);

export const formatPrice = (value: number, currency: string): string =>
	new Intl.NumberFormat(bcp47Helper(useUserStore().language), {
		style: "currency",
		currency,
	}).format(value);

export const formatDate = (
	date: Date,
	overrides?: Intl.DateTimeFormatOptions,
): string =>
	date.toLocaleDateString(bcp47Helper(useUserStore().language), {
		year: "numeric",
		month: "numeric",
		day: "numeric",
		...overrides,
	});

export const formatTime = (
	date: Date,
	overrides?: Intl.DateTimeFormatOptions,
): string =>
	date.toLocaleTimeString(bcp47Helper(useUserStore().language), {
		hour: "2-digit",
		minute: "2-digit",
		...overrides,
	});

export const formatDateTime = (
	date: Date,
	overrides?: Intl.DateTimeFormatOptions,
): string =>
	date.toLocaleDateString(bcp47Helper(useUserStore().language), {
		hour: "2-digit",
		minute: "2-digit",
		...overrides,
	});

export const abbrNumber = (
	value: number | string,
	withoutTags: boolean = false,
): string => {
	if (!value) return "0";

	value = +value.toString();

	const thresholds = [1e9, 1e6];
	const abbr = ["B", "M"];
	for (let i = 0; i < thresholds.length; i++) {
		if (value >= thresholds[i]) {
			const formattedValue = (value / thresholds[i]).toLocaleString(
				useUserStore().language,
				{
					minimumFractionDigits: 0,
					maximumFractionDigits: 3,
				},
			);
			const suffix = withoutTags ? ` ${abbr[i]}` : ` <b>${abbr[i]}</b>`;

			return `${formattedValue}${suffix}`;
		}
	}

	return value.toString();
};

export const convertUnixTimeToRemainingSeconds = (unixTime: number): number => {
	const now = Date.now() / 1_000;
	const remainingSeconds = Math.max(0, unixTime - now);

	return remainingSeconds;
};
